<template>
    <div class="giving giving-little-extra p-5">
        <img class="open-box" :srcset="
            `${$store.state.appUrl}/img/pwa/login/open-box.svg, ${$store.state.appUrl}/img/pwa/login/open-box.svg`
        " :src="`${$store.state.appUrl}/img/pwa/login/open-box.svg`" alt="Thrive" width="33%" height="33%" />

        <h3 class="text-white font-bold text-20 mb-1 ml-3 text-center">
            {{ $t("Give a little extra!") }}
        </h3>
        <div class="giving-chooser pt-8 pb-2">
            <ul ref="givingChooser" class="mb-2 giving-chooser__list flex flex-nowrap bg-white relative">
                <li class="giving-chooser__item flex-grow flex" v-for="item in extraMoney" :key="item.money">
                    <button v-ripple type="button" :ref="
                        `extra${item.type === 'number' ? item.money : 'last'
                        }`
                    " class="giving-chooser__btn smd:text-16 text-14 font-bold tracking-tight text-center w-full"
                        :class="{ 'active-extra': item.money === activeExtra }"
                        @click="chooserExtraHandler(item.money, item.type)">
                        <span v-if="item.type === 'number'">$</span>{{ item.money }}
                    </button>
                </li>
                <li class="absolute giving-chooser__item-bg" v-bind:style="styles"></li>
            </ul>
            <div v-show="showCustomExtra">
                <p class="mb-6 text-14 tracking-normal text-white leading-tight">
                    {{
                            $t(
                                "Look at you making an impact! Enter your gift below:"
                            )
                    }}
                </p>
                <input type="text"
                    class="giving-chooser__custom block bg-white font-bold tracking-tight text-text text-content text-20 text-center mx-auto p-2"
                    v-model="extraModel" @input="customExtraHandler" />
            </div>
            <Button type="button" :click-handler="addExtra" classes="gift-button table mx-auto mt-4"
                :text="$t('Make a One-Time Gift')"></Button>
        </div>
    </div>
</template>

<script>
import Button from "../UI/Button";
import mixins from "../../config/mixins";

export default {
    name: "Extra",
    components: { Button },
    mixins: [mixins.helpers],

    data: function () {
        return {
            extraMoney: [
                {
                    money: 1,
                    type: "number"
                },
                {
                    money: 5,
                    type: "number"
                },
                {
                    money: 10,
                    type: "number"
                },
                {
                    money: 25,
                    type: "number"
                },
                {
                    money: this.$t("Custom"),
                    type: "text"
                }
            ],
            extra: 1,
            extraModel: "$1",
            showCustomExtra: false,
            activeExtra: 1,
            styles: {
                width: "",
                left: "",
                right: ""
            },
            currentRefName: "extra1",
        };
    },
    mounted() {
        this.generateStyles();
        window.addEventListener("resize", () => {
            this.generateStyles();
        });
    },

    methods: {
        chooserExtraHandler: function (val, type) {
            this.currentRefName = `extra${type === "number" ? val : "last"}`;
            this.generateStyles();
            this.activeExtra = val;
            if (type === "number") {
                this.extra = val;
                this.extraModel = "$" + val;
                this.showCustomExtra = false;
            } else {
                this.showCustomExtra = true;
            }
        },
        customExtraHandler: function (e) {
            this.extra = e.target.value.replace(/\D/g, "");
            this.extraModel = "$" + this.extra;
        },
        addExtra: function () {
            this.$fire({
                type: "warning",
                title: `Would you like to give a gift of $${this.extra}?`,
                showCancelButton: true,
                cancelButtonText: "No",
                confirmButtonText: "Yes"
            }).then(r => {
                if (!!r.value && r.value) {
                    this.doPayment();
                }
            });
        },
        doPayment: function () {
            this.$http
                .post("user/sendamount", {
                    amount: parseFloat(this.extra) * 100
                })
                .then(res => {
                    if (res && res.status !== undefined && res.status) {
                        this.$setState(
                            "monthDonation",
                            parseFloat(res.total).toFixed(2)
                        );
                        this.$setState(
                            "lastTransaction",
                            parseFloat(res.last_transaction).toFixed(2)
                        );
                    } else if (res && res.route !== undefined && res.route) {
                        this.$toastr.Add({
                            msg: "Click to link card to activate your account",
                            clickClose: true,
                            type: "info",
                            timeout: 15000,
                            onClicked: () => {
                                this.$toastr.removeByType("error");
                                this.$router.push("/settings?target=card");
                            }
                        });
                    }
                });
        }
    }
};
</script>
